import { GoogleTagManager } from "@next/third-parties/google";

export const InitializeGoogleTagManager = () => {
  return <GoogleTagManager gtmId={`${process.env.NEXT_PUBLIC_GTMID}`} />;
};
